import { Component, OnInit } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { SignInPage } from '../../pages/sign-in/sign-in.page';
import { Router } from '@angular/router';
import { SignUpPage } from '../../pages/sign-up/sign-up.page';
import { PopoverController, ModalController } from '@ionic/angular';
import { HomePage } from '../../pages/home/home.page';
import { MyOrdersPage } from '../../pages/my-orders/my-orders.page';
import { AccountPage } from '../../pages/account/account.page';
import { PrivacyPage } from '../../pages/privacy/privacy.page';
import { TosPage } from '../../pages/tos/tos.page';
import { ImpressumPage } from '../../pages/impressum/impressum.page';
import { MatSnackBar } from '@angular/material/snack-bar';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { NavigationService } from 'src/app/services/navigation.service';
import { Api } from 'src/smoothr-web-app-core/api/api';
import { SignInModalComponent } from '../sign-in-modal/sign-in-modal.component';
import { SignUpModalComponent } from '../sign-up-modal/sign-up-modal.component';
import { UserDataModalComponent } from '../user-data-modal/user-data-modal.component';
import { MyOrdersModalComponent } from '../my-orders-modal/my-orders-modal.component';
import { LoyaltySliderComponent } from '../loyalty-components/loyalty-slider/loyalty-slider.component';
import { PreorderType } from 'src/smoothr-web-app-core/enums/PreorderType';
import { OrderNotExistModalComponent } from '../order-not-exist-modal/order-not-exist-modal.component';
import { SelectLanguageModalComponent } from '../select-language-modal/select-language-modal.component';
enum Language {
	GreatBritain = 'en',
	German = 'de',
	Czech = 'cr',
}

@Component({
	selector: 'app-menu-modal',
	templateUrl: './menu-modal.component.html',
	styleUrls: ['./menu-modal.component.scss'],
})
export class MenuModalComponent extends RepositoryDirective implements OnInit {
	environment = environment;
	languageEnum = Language;
	ifMyOrderExist = false;
	checkIfVenueExistImpressum;
	constructor(
		public repository: RepositoryService,
		private router: Router,
		private modalController: ModalController,
		private snackbarCtrl: MatSnackBar,
		public translate: TranslateService,
		private navigationService: NavigationService,
		private modalCtrl: ModalController
	) {
		super(repository);
	}
	ngOnInit(): void {
		super.ngOnInit();
		this.checkIfVenueExistImpressum = '';
		this.loadOrders();
		if (this.repository._venue && this.repository._order) {
			if (this.repository._venue) {
				const ifUrlIncludes = this.router.url.includes('home') || this.router.url.includes('map');
				console.log(ifUrlIncludes, this.router.url, !this.repository._venue?.legal?.imprint && !ifUrlIncludes);
				if (!this.repository._venue?.legal?.imprint && !ifUrlIncludes) {
					this.checkToShowData(this.repository._venue._id);
				}
				return;
			} else {
				this.checkIfVenueExistImpressum = '';
			}
		}
	}
	async loadOrders() {
		console.log('load orders', !this.customer);
		if (!this.customer) {
			console.log('user not loaded');
			return;
		}
		try {
			const result = await Api.getCustomerOrders(this.customer.uid);
			if (result.data.withPayment) {
				const resultOrders = result.data.withPayment.filter(it => it?.preorder?.type !== PreorderType.FOOD_SPOT);
				console.log(resultOrders);
				if (resultOrders.length > 0) {
					this.ifMyOrderExist = true;
				}
			}
		} catch (e) {}
	}
	private async checkToShowData(venueId: string) {
		try {
			const legal = (await Api.getLegal(venueId)).data;
			if (legal.type === 'pdf') {
				this.checkIfVenueExistImpressum = legal.imprint;
			}
		} catch (e) {
			console.error('Error while getting legal information');
			console.error(e);
		}
	}
	async signIn() {
		try {
			await this.modalController.dismiss();
		} catch (e) {}
		const result = await SignInModalComponent.show(this.modalCtrl);
		if (result === 'sign-up') {
			this.signUp();
		}
	}

	async signUp() {
		try {
			await this.modalController.dismiss();
		} catch (e) {}
		const result = await SignUpModalComponent.show(this.modalCtrl);
	}

	async mySpace() {
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.account();
		} catch (e) {
			await this.navigationService.account();
		}
	}

	async myOrders() {
		try {
			await this.modalController.dismiss();
		} catch (e) {}
		if (this.ifMyOrderExist) {
			MyOrdersModalComponent.show(this.modalController, this.repository.customer);
		} else {
			let isInMenu = false;
			try {
				isInMenu = this.router.url.includes('menu');
			} catch (e) {}
			const result = await OrderNotExistModalComponent.show(this.modalCtrl, isInMenu);
			if (result) {
				this.navigationService.map();
			}
		}
	}

	async logout() {
		try {
			this.repository.customerAuth.emit(null);
			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_success'), null, {
				duration: 2000,
			});
		} catch (e) {
			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_error'), null, {
				duration: 2000,
			});
		}
		await this.modalController.dismiss();
	}

	async home() {
		await this.modalController.dismiss();
		await this.navigationService.home();
	}

	async privacy() {
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.privacy();
		} catch (e) {
			await this.navigationService.privacy();
		}
	}

	async tos() {
		await this.modalController.dismiss();
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.tos();
		} catch (e) {
			await this.navigationService.tos();
		}
	}

	async impressum() {
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.imprint();
		} catch (e) {
			await this.navigationService.imprint();
		}
	}
	async allergens() {
		await this.modalController.dismiss();
		// TODO open PDF
	}

	dismiss() {
		this.modalController.dismiss();
	}
	changeLang(language: string) {
		this.translate.setDefaultLang(language);
		this.translate.use(language);
	}
	async willBeSoon() {
		await this.modalController.dismiss();

		this.snackbarCtrl.open('No design, will be soon...', null, {
			duration: 3000,
		});
	}
	async account() {
		try {
			await this.modalController.dismiss();
		} catch (e) {}
		await UserDataModalComponent.show(this.modalController);
	}
	async cookie() {
		await this.modalController.dismiss();

		this.navigationService.cookie();
	}
	async myPromo() {
		try {
			await this.modalController.dismiss();
		} catch (e) {}
		if (this.repository.customer.isAnonymous) {
			const result = await LoyaltySliderComponent.show(this.modalCtrl, true);
			if (result) {
				this.signIn();
			}
		} else {
			this.navigationService.loyalty();
		}
	}

	async selectLanguageModal() {
		await SelectLanguageModalComponent.show(this.modalCtrl);
	}
}
